<template>
  <kbd class="py-1 px-2 border-2 border-black rounded text-xs">
    <slot />
  </kbd>
</template>

<script setup lang="ts"></script>

<style scoped></style>
